/**
 * DRM-free HLS load options for podcast video.
 *
 * Kept out of `videoPlayback.ts` on purpose: that module statically pulls the
 * PRS/DRM/vinyl-amzn graph, which is lazy behind the video route. This helper
 * is consumed on the core podcast playback path, so it must stay
 * dependency-light or it'd drag PRS into the app-core chunk.
 */

import { createShortUid } from '@amazon/vinyl-util'
import type { VinylAmznTrackLoadOptions } from '@amzn/vinyl-amzn'

/**
 * Load options for a DRM-free podcast video HLS manifest. Unlike the
 * music-video path (Widevine/FairPlay), podcast video ships a plain .m3u8 with
 * no license dance.
 *
 * Uses Vinyl's `hls` track factory (MSE-based), not the `src` factory, so the
 * manifest plays on every browser — not just Safari's native HLS. The
 * HLS_VND vs HLS_XMPEG MIME split is a no-op here: the engine keys off the
 * segments, not the MIME label.
 */
export function podcastVideoUrlToLoadOptions(videoUrl: string): VinylAmznTrackLoadOptions {
    return {
        type: 'hls',
        uri: videoUrl,
        config: { extra: { uuid: createShortUid() } },
    }
}
